module.exports = __webpack_public_path__ + "media/images/undraw/meet_the_team-48a9da61ced5f9e40050b9705a777fb9.png";